import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import ImportIcon from "@/components/icons/importIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportButton',
  props: {
    title: {
        type: String,
        default: "Import"
    },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit

const action = () => {
    emit("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonComponent, {
    customClass: "quaternary",
    onClick: action
  }, {
    default: _withCtx(() => [
      _createVNode(ImportIcon, { class: "w-4 h-4 object-contain -ml-2 mr-1 icon" }),
      _createElementVNode("span", null, _toDisplayString(__props.title), 1)
    ]),
    _: 1
  }))
}
}

})